import { Image, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    logo: {
        display: "flex",
        height: "60px",
        margin: '0 auto', // Center logo for mobile view
        
        '@media (min-width: 600px)': { // Remove margin for larger screens
            margin: '0',
        },
    }
});

const Logo = () => {
    const { t } = useTranslation("general");
    const styles = useStyles();
    
    return (
        <Image
            loading="lazy"
            src="/img/logos/dolphin-solutions_logo_blue-white.png"
            alt={t("companyName")}
            className={styles.logo}
            />
    );
}

export default Logo;